import { inject, provideEnvironmentInitializer } from '@angular/core';

import { CosFeatureFlagsToolbarControlsSet } from '@cosmos/feature-flags-toolbar';

export function withPresentationTemplateSelect() {
  return provideEnvironmentInitializer(() => {
    const controls = inject(CosFeatureFlagsToolbarControlsSet);
    controls.add(async () => {
      const { FeatureFlagsTemplateSelectComponent } = await import(
        './lib/feature-flags-template-select.component'
      );
      return FeatureFlagsTemplateSelectComponent;
    });
  });
}
